import React from 'react';
import { Box, Typography } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import error from '@images/icons/error.png';
import CustomButton from '../UI/CustomButton';

interface ErrorProps {
  fullHeight?: boolean;
  onRetry?: () => void;
}
const Error: React.FC<ErrorProps> = (props) => {
  const { fullHeight = false, onRetry } = props;

  return (
    <main>
      <Box className='mainError' sx={{ height: fullHeight ? '100vh' : '500px' }}>
        <img src={error} alt='' />
        <Box className='flexCenter' gap={1} mt={2}>
          <Typography color='text.darker'>خطا در دریافت اطلاعات</Typography>
          {onRetry && (
            <CustomButton variant='outlined' onClick={onRetry}>
              <RefreshRoundedIcon color='primary' />
              <Typography>تلاش دوباره</Typography>
            </CustomButton>
          )}
        </Box>
      </Box>
    </main>
  );
};

export default Error;
